import { Link } from "react-router-dom";
import { services } from "@/mocks/services";
import SectionTitle from "@/components/base/SectionTitle";

export default function ServicesPreview() {
  const shown = services.slice(0, 6);
  return (
    <section id="services" className="bg-background-100 py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-4 md:px-10">
        <SectionTitle
          eyebrow="Services"
          title="サービス一覧"
          description="マンションの共用部清掃を軸に、お客様の『あったら助かる』を幅広く。全て自社スタッフが直接対応します。"
        />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-7">
          {shown.map((s) => (
            <Link
              key={s.slug}
              to="/services"
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200 hover:border-primary-300 transition-colors cursor-pointer flex flex-col"
            >
              <div className="relative h-48 md:h-52 overflow-hidden">
                <img
                  src={s.image}
                  alt={s.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute top-3 left-3 bg-background-50/95 backdrop-blur px-3 py-1.5 rounded-md flex items-center gap-2 text-xs text-primary-700">
                  <i className={s.icon}></i>
                  {s.price}
                </div>
              </div>
              <div className="p-6 flex-1 flex flex-col">
                <h3 className="font-heading text-lg text-foreground-950 mb-2">
                  {s.title}
                </h3>
                <p className="text-sm text-foreground-700 leading-relaxed mb-4 text-justify">
                  {s.subtitle}
                </p>
                <div className="mt-auto flex items-center text-sm text-primary-600 group-hover:text-primary-700">
                  詳しく見る <i className="ri-arrow-right-line ml-2"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}